var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0833 15.5001C30.0833 7.45008 23.55 0.916748 15.5 0.916748C7.45001 0.916748 0.916672 7.45008 0.916672 15.5001C0.916672 22.5584 5.93334 28.4355 12.5833 29.7917V19.8751H9.66667V15.5001H12.5833V11.8542C12.5833 9.03966 14.8729 6.75008 17.6875 6.75008H21.3333V11.1251H18.4167C17.6146 11.1251 16.9583 11.7813 16.9583 12.5834V15.5001H21.3333V19.8751H16.9583V30.0105C24.3229 29.2813 30.0833 23.0688 30.0833 15.5001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFac);
export default __webpack_public_path__ + "static/media/fac.f10c4b8d8f959c73f695386d34d078ca.svg";
export { ForwardRef as ReactComponent };